import { GI18NText } from '~/presentation/common';
import { Banner, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { dayjs } from '~/utils/dayjs';

const HOLIDAY_START = dayjs.tz('2026-04-23 00:00', 'Asia/Ho_Chi_Minh');
const HOLIDAY_END = dayjs.tz('2026-05-03 23:59', 'Asia/Ho_Chi_Minh');

const isWithinHolidayWindow = () => {
  const now = dayjs.utc();
  return now.isAfter(HOLIDAY_START) && now.isBefore(HOLIDAY_END);
};

export const BannerHolidayNotice = () => {
  const { t } = useTranslation();

  if (!isWithinHolidayWindow()) return null;

  return (
    <Banner title={t('Holidays Support Notice')} tone="info">
      <GI18NText
        as="p"
        variant="bodyMd"
        transformers={{
          1: (text) => (
            <Text as="span" fontWeight="semibold">
              {text}
            </Text>
          ),
        }}
      >
        {t(
          'Due to [1]Public Holidays[], our Support team will have limited availability from [1]April 26 to May 03 (GMT+7)[]. Response times may be slightly delayed. We apologize for any inconvenience.',
        )}
      </GI18NText>
    </Banner>
  );
};
